/* Kaching Badge Override (KBO)
   Reads config from <meta name="kbo-config" data-*> in <head>, replaces the text of every
   .kaching-bundles__bar-most-popular__content node that matches the user-defined regex
   (unless the product handle is excluded or the text is in the protect list).
   Idempotent (trim-safe). Skips elements with child nodes. MutationObserver catches
   Kaching re-renders (quick-add modal etc.) with rAF debouncing. */
(function () {
  'use strict';

  var meta = document.querySelector('meta[name="kbo-config"]');
  if (!meta) return; // snippet not rendered or feature disabled

  var NEVER = /(?!)/; // empty negative lookahead — never matches anything, immune to 'm' flag refactors

  function safeRegex(pattern, fallback) {
    if (!pattern || !pattern.trim()) return fallback;
    try { return new RegExp(pattern, 'i'); }
    catch (e) {
      if (window.console) console.warn('[KBO] invalid regex:', pattern, e && e.message);
      return fallback;
    }
  }

  var rawNewText = (meta.getAttribute('data-new-text') || '').trim();
  if (!rawNewText) return; // nothing to set
  var rawEmoji = (meta.getAttribute('data-emoji') || '').trim();

  var cfg = {
    newText: rawNewText,
    matchRe: safeRegex(meta.getAttribute('data-match') || '', NEVER),
    excludeRe: safeRegex(meta.getAttribute('data-exclude-text') || '', NEVER),
    excludeHandles: (meta.getAttribute('data-exclude-handles') || '')
      .split(/[\s,;]+/).map(function (s) { return s.trim().toLowerCase(); })
      .filter(Boolean),
    emoji: rawEmoji
  };

  var FINAL = (cfg.emoji ? cfg.emoji + ' ' : '') + cfg.newText;
  var SELECTOR = '.kaching-bundles__bar-most-popular__content';
  var FLAG_ATTR = 'data-kbo-patched';

  function currentHandle() {
    var s = document.querySelector('script.kaching-bundles-product');
    if (s) {
      try {
        var data = JSON.parse(s.textContent);
        if (data && data.handle) return String(data.handle).toLowerCase();
      } catch (e) { /* fall through */ }
    }
    var m = (location.pathname || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1].toLowerCase() : '';
  }

  function patch() {
    var handle = currentHandle();
    if (handle && cfg.excludeHandles.indexOf(handle) !== -1) return;

    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];

      // Idempotence (trim-safe): already-patched and content matches FINAL
      if (el.getAttribute(FLAG_ATTR) === '1' && el.textContent.trim() === FINAL) continue;

      // Safety: skip if element contains child ELEMENTS (Kaching may wrap text in a <span>);
      // overwriting textContent would destroy them and trigger an infinite mutation loop
      if (el.childElementCount > 0) continue;

      var txt = (el.textContent || '').trim();
      if (!txt) continue;
      if (cfg.excludeRe.test(txt)) continue;
      if (!cfg.matchRe.test(txt)) continue;

      if (el.textContent !== FINAL) el.textContent = FINAL;
      el.setAttribute(FLAG_ATTR, '1');
    }
  }

  function safePatch() {
    try { patch(); }
    catch (e) { if (window.console) console.warn('[KBO]', e && e.message); }
  }

  // Initial pass
  safePatch();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safePatch, { once: true });
  }
  // Cold-load safety (Kaching may render after script init)
  setTimeout(safePatch, 500);

  // Catch Kaching re-renders (quick-add modal, variant changes). rAF-debounced.
  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    var schedule = window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); };
    schedule(function () {
      queued = false;
      // Trim-safe stale-flag clearing (avoids whitespace ping-pong loop)
      var patched = document.querySelectorAll(SELECTOR + '[' + FLAG_ATTR + '="1"]');
      for (var i = 0; i < patched.length; i++) {
        if (patched[i].textContent.trim() !== FINAL) patched[i].removeAttribute(FLAG_ATTR);
      }
      safePatch();
    });
  }

  if (document.body && typeof MutationObserver === 'function') {
    try {
      new MutationObserver(queue).observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });
    } catch (e) {
      if (window.console) console.warn('[KBO] observer failed:', e && e.message);
    }
  }
})();